__turbopack_context__.v({
  "codeWrapper": "CodeBlockNodeView-module-module__eggk6q__codeWrapper",
});
